<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    title="选择工厂"
    top="8vh"
    width="800px"
  >
    <TableSelect
      ref="tableSelect"
      :filter="filter"
      :columns="columns"
      module="basic"
      url="factorys"
      @select="selectFactory"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" ref="form" :model="filter">
          <el-form-item label="编号" prop="factoryNo">
            <el-input v-model.trim="filter.factoryNo" placeholder="请输入工厂编号" clearable />
          </el-form-item>
          <el-form-item label="名称" prop="factoryName">
            <el-input v-model.trim="filter.factoryName" placeholder="请输入工厂名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </TableSelect>
  </el-dialog>
</template>

<script>
import TableSelect from "@/components/TableSelect.vue";

export default {
  components: { TableSelect },
  data() {
    return {
      dialogVisible: false,
      filter: {
        factoryNo: "",
        factoryName: "",
      },
      columns: [
        {
          title: "编号",
          key: "factoryNo",
          width: 100,
          align: "center",
        },
        {
          title: "名称",
          key: "factoryName",
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          align: "center",
        },
      ],
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.$refs.tableSelect.loadData();
      });
    },

    // 选择工厂
    selectFactory(row) {
      this.dialogVisible = false;
      this.$emit("select", row);
    },

    // 重置
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
      this.$refs.tableSelect.loadData(1);
    },
  },
};
</script>
